import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import update from "react-addons-update";
import PropTypes from "prop-types";
import * as strings from '../constants/strings';
import {run, ruleRunner} from '../validation/ruleRunner.js'
import {required, mustMatch, minLength, maxLength, email, alpha} from '../validation/rules';
import * as RegActions from '../actions/registration';
import FormInput from '../components/FormInput';
import Button from "../components/Button";

const fieldValidations = [
    ruleRunner("email", strings.STR_REG_LABEL_EMAIL, required, email),
    ruleRunner("full_name", strings.STR_REG_LABEL_FULL_NAME, required, minLength(5), maxLength(255), alpha),
    ruleRunner("password1", strings.STR_REG_LABEL_PASSWORD1, required, minLength(5), maxLength(255), alpha),
    ruleRunner("password2", strings.STR_REG_LABEL_PASSWORD2, required, mustMatch("password1", strings.STR_REG_LABEL_PASSWORD1))
];

class Registration extends Component {

    constructor(props) {
        super(props);
        this.state = {
            valid: false,
            validationErrors: {},
            showErrors: false
        }
    }

    componentDidMount() {
        // Run validations on initial state
        this.setState({validationErrors: run(this.state, fieldValidations)});
    }

    errorFor(field) {
        return this.state.validationErrors[field] || "";
    }

    onFieldChanged(field) {
        return e => {
            let newState = update(this.state, {
                [field]: {$set: e.target.value}
            });
            newState.validationErrors = run(newState, fieldValidations);
            newState.valid = (Object.keys(newState.validationErrors).length === 0);
            this.setState(newState);

        }
    }

    onKeyDown(e) {
        if (e.keyCode === 13) {
            this.doRegistration();
        }
    }

    doRegistration() {
        const {registration: {isFetching: busy}, regActions} = this.props;
        this.setState({showErrors: true});
        if (!busy && this.state.valid) {
            regActions.register(this.state.email, this.state.full_name, this.state.password);
        }
    }

    isBusy() {
        const {registration, login} = this.props;
        return registration.isFetching || login.isFetching;
    }

    render() {
        const {registration: {errors: serverErrors}, regActions} = this.props;
        const busy = this.isBusy();
        return(
            <div className="modal registration">
                <form onKeyDown={e => this.onKeyDown(e)}>
                    <FormInput name="email" autoFocus={true}
                               label={strings.STR_REG_LABEL_EMAIL} placeholder={strings.STR_REG_PLACEHOLDER_EMAIL}
                               onFieldChanged={this.onFieldChanged('email')}
                               showError={this.state.showErrors} errorText={this.errorFor("email")} serverErrors={serverErrors["email"] || []}/>

                    <FormInput name="full_name"
                               label={strings.STR_REG_LABEL_FULL_NAME} placeholder={strings.STR_REG_PLACEHOLDER_FULL_NAME}
                               onFieldChanged={this.onFieldChanged('full_name')}
                               showError={this.state.showErrors} errorText={this.errorFor("full_name")} serverErrors={serverErrors["name"] || []}/>

                    <FormInput name="password1"
                               label={strings.STR_REG_LABEL_PASSWORD1}
                               placeholder={strings.STR_REG_PLACEHOLDER_PASSWORD1} type="password"
                               onFieldChanged={this.onFieldChanged('password1')}
                               showError={this.state.showErrors} errorText={this.errorFor("password1")} serverErrors={serverErrors["password"] || []}/>

                    <FormInput name="password2"
                               label={strings.STR_REG_LABEL_PASSWORD2}
                               placeholder={strings.STR_REG_PLACEHOLDER_PASSWORD2} type="password"
                               onFieldChanged={this.onFieldChanged('password2')}
                               showError={this.state.showErrors} errorText={this.errorFor("password2")}/>

                    <div className="form-group">
                        <div className="btn-toolbar">
                            <Button className={"register" + (busy ? " busy" : "")} onClick={this.doRegistration.bind(this)} disabled={busy ? "" : ""}>
                                <span className="loader"></span><span className="title">{strings.STR_REG_REGISTER}</span>
                            </Button>
                        </div>
                        <div className="link-block center">
                            <a href="" onClick={(event) => {regActions.cancelRegistration()}}>{strings.STR_REG_HAS_CREDS}</a>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

Registration.propTypes = {
    registration: PropTypes.object.isRequired,
    login: PropTypes.object.isRequired,
    regActions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        registration: state.users.registration,
        login: state.users.login
    }
};

const mapDispatchToProps = dispatch => {
    return {
        regActions: bindActionCreators(RegActions, dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Registration);


// WEBPACK FOOTER //
// ./src/containers/Registration.js